import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PricingCancel() {
  return (
    <div className="min-h-screen bg-[#EDF1FB]">
      <Navbar variant="solid" />
      <section className="pt-[140px] pb-24 px-6">
        <div
          data-testid="pricing-cancel"
          className="max-w-2xl mx-auto text-center bg-white rounded-3xl p-10 md:p-14 border border-[#E2E8F4] shadow-sm"
        >
          <XCircle className="w-14 h-14 text-amber-500 mx-auto" />
          <h1 className="mt-6 text-3xl md:text-4xl font-extrabold text-[#0A1F47]">
            Checkout cancelled
          </h1>
          <p className="mt-3 text-[#0A1F47]/70 max-w-lg mx-auto">
            No charge was made. Questions about the plans? Our team is happy to help you pick the right tier.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/pricing" className="btn-navy inline-flex">
              Back to Pricing <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/#contact"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-[#0A1F47]/20 text-[#0A1F47] font-semibold hover:bg-[#F5F7FA] transition-colors"
            >
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
